import React from 'react';

function DropdownHeader({children}) {
  return(
    <p className="fs-2 c-neutral-400 px-2 ls-wide tt-uppercase py-1">{children}</p>
  )
}

export default DropdownHeader